import React from "react";
import { Box, Typography, Link, Grid } from "@mui/material";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: "#C41E3A",
        color: "#FFFFFF",
        padding: { xs: "20px 16px", sm: "24px 32px" },
        textAlign: "center",
        marginTop: "auto",
      }}
    >
      <Grid container justifyContent="center" spacing={3} sx={{ mb: 2 }}>
        <Grid item>
          <Link 
            href="https://apps.apple.com/ca/app/christmas-light-map/id6755755089" 
            target="_blank" 
            rel="noopener noreferrer"
            sx={{ display: 'inline-block' }}
          >
            <img 
              src="https://developer.apple.com/app-store/marketing/guidelines/images/badge-download-on-the-app-store.svg" 
              alt="Download on the App Store"
              style={{ height: 40, width: 'auto' }}
            />
          </Link>
        </Grid>
      </Grid>
      <Typography
        variant="body2"
        sx={{
          fontFamily: "'Playfair Display', serif",
          fontSize: { xs: "0.875rem", sm: "0.9375rem" },
          opacity: 0.9,
        }}
      >
        © {currentYear} Christmas Lights Map. All rights reserved.
      </Typography>
    </Box>
  );
};

export default Footer;






